import React from "react";
import './about.css'
import Me from '../../assets/me.png';

const About = () => {
    return (
       <section id='about'>
           <br/>
           <h2> About Me</h2>
           <div className="container about_container">
               <div className="about_me">
                    <div className="about_me-image">
                        <img src={Me} alt="About Image"/>
                    </div>

               </div>
                <div className="about_content">
                    <diV className='about_cards'>
                    <article className="about_card">
                           <a href='#skills'>Skills</a>
                        </article>
                        <article className="about_card">
                           <a href='#experience'>Experience</a>
                        </article>
                        <article className="about_card">
                           <a href='#education'>Education</a>
                        </article>
                        <article className="about_card">
                           <a href='#projects'>Projects</a>
                        </article>
                    </diV>
                    <p>Hardworking and reliable, focused on going above and beyond to support the team and serve customers. Motivated to continue to learn and grow as a developer professional.</p>
                    <a href="#contact" className="btn btn-primary">Let's Talk</a>
                </div>
           </div>
       </section>
    )
}

export default About